import clsx from 'clsx';
import { PrismicNextImage } from '@prismicio/next';
import * as prismicH from '@prismicio/helpers';

import { BaseSlice } from '../../components/BaseSlice';
import { Bounded } from '../../components/Bounded';
import { RichText } from '../../components/RichText';
import PrismicLink from '../../components/PrismicLink';

/**
 * @typedef {import("@prismicio/client").Content.PartnersSlice} PartnersSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<PartnersSlice>} PartnersProps
 * @type {import("react").FC<PartnersProps>}
 */
const Partners = ({ slice, index }) => {
  return (
    <Bounded as="section" index={index}>
      <BaseSlice>
        <div
          className={clsx(
            slice.primary?.center && 'text-center',
            prismicH.isFilled.richText(slice.primary?.text) && 'mb-5'
          )}>
          <RichText field={slice.primary?.text} />
        </div>

        {slice.variation === 'default' ? (
          <PartnersList slice={slice} />
        ) : slice.variation === 'compact' ? (
          <PartnersCompact slice={slice} />
        ) : null}
      </BaseSlice>
    </Bounded>
  );
};

const PartnersList = ({ slice }) => {
  return (
    <div className="row">
      {slice._items.map(({ partner, role }, idx) => (
        <div key={idx} className="mb-4 col-sm-6 col-lg-3 col-xl-2 text-center">
          <div className="mb-3">
            {prismicH.isFilled.image(partner?.data?.logo) &&
              (prismicH.isFilled.link(partner?.data?.website) ? (
                <PrismicLink
                  className="text-reset"
                  target="_blank"
                  field={partner.data.website}>
                  <PrismicNextImage
                    field={partner.data.logo}
                    alt={partner.data.logo.alt}
                    className="img-fluid rounded bg-white object-fit-contain p-2"
                    style={{ width: 200, height: 200 }}
                  />
                </PrismicLink>
              ) : (
                <PrismicNextImage
                  field={partner?.data?.logo}
                  alt={partner?.data?.logo?.alt}
                  className="img-fluid rounded bg-white object-fit-contain p-2"
                  style={{ width: 200, height: 200 }}
                />
              ))}
          </div>
          <div class="fw-bold">
            {prismicH.isFilled.link(partner?.data?.website) ? (
              <PrismicLink
                className="text-reset"
                target="_blank"
                field={partner.data.website}>
                {partner?.data?.name}
              </PrismicLink>
            ) : (
              partner?.data?.name
            )}
          </div>
          {role ? (
            <p class="mb-3">
              {role[0]?.toUpperCase()}
              {role.slice(1)}
            </p>
          ) : null}
        </div>
      ))}
    </div>
  );
};

const PartnersCompact = ({ slice }) => {
  return (
    <div class="row">
      {slice._items.map(({ partner }, idx) => (
        <div key={idx} className="col-sm-6 col-lg-3 col-xl-2 text-center">
          {prismicH.isFilled.link(partner?.data?.website) ? (
            <PrismicLink
              className="text-reset"
              target="_blank"
              field={partner.data.website}>
              <PrismicNextImage
                field={partner?.data.logo}
                alt={partner?.data.logo?.alt || partner?.data.name}
                className="img-fluid rounded bg-white object-fit-contain p-1"
                style={{ width: 200, height: 200 }}
              />
            </PrismicLink>
          ) : (
            <PrismicNextImage
              field={partner?.data?.logo}
              alt={partner?.data?.logo?.alt || partner?.data?.name}
              className="img-fluid rounded bg-white object-fit-contain p-1"
              style={{ width: 200, height: 200 }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default Partners;
